import React, { PropTypes } from 'react'

import ReservationSummary from './reservations'
import WaitlistSummary from './waitlist'
import Spacer from '../../spacer'

const SessionSaleSummary = props => {
  const { sessionSaleId } = props.params

  return (
    <div>
      <Spacer />
      <ReservationSummary sessionSaleId={sessionSaleId} />
      <Spacer />
      <WaitlistSummary sessionSaleId={sessionSaleId} />
    </div>
  )
}

// @ts-ignore
SessionSaleSummary.propTypes = {
  params: PropTypes.shape({
    sessionSaleId: PropTypes.string.isRequired
  }).isRequired
}

export default SessionSaleSummary
